import { Controller, useForm } from 'react-hook-form';
import { debounce } from '../../utils/debounce';

export function Teste() {
  const { handleSubmit, register, control } = useForm();

  function onSubmit(data) {
    console.log(data);
  }

  const handleDebounce = debounce(onSubmit, 1000);

  return (
    <>
      <form
        onChange={handleSubmit((data) => {
          handleDebounce(data);
        })}>
        <input {...register('nome')} />
        <input {...register('email')} />
        <Controller
          control={control}
          name="teste"
          render={({ field }) => (
            <select {...field}>
              <option value="1">1</option>
              <option value="2">2</option>
            </select>
          )}
        />
      </form>
    </>
  );
}
